<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" width="700">
      <v-card min-height="500">
        <div class="preview-box">
          <table>
            <tr>
              <td>
                <table>
                  <tr>
                    <th class="time-cell border">Laikas</th>
                    <th class="user-cell border">Vartotojas</th>
                    <th class="comment-cell border">Pastaba</th>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <div class="table-data">
                  <table>
                    <tr v-for="(comment, i) in comments" :key="i">
                      <td class="time-cell border">{{comment.created_at}}</td>
                      <td class="user-cell border">{{comment.user_name}}</td>
                      <td class="comment-cell border">{{comment.text}}</td>
                    </tr>
                  </table>
                </div>
              </td>
            </tr>
          </table>
        </div>

        <div class="input-group mb-3">
          <input
            id="comment-input"
            v-model="comment"
            type="text"
            class="form-control"
            :placeholder="$t('comments_preview_dialog.comment')"
            :aria-label="$t('comments_preview_dialog.comment')"
            aria-describedby="basic-addon2"
          />
          <div class="input-group-append">
            <button class="input-group-text" @click="saveComment">{{$t('comments_preview_dialog.confirm')}}</button>
          </div>
        </div>

        <div class="cancel-button">
          <v-btn
            color="primary"
            flat
            @click="dialog = false"
          >{{$t('comments_preview_dialog.cancel')}}</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Comment from "@/models/Comment.js";
import Helper from "@/models/Helper.js";
export default {
  data() {
    return {
      dialog: false,
      comments: [],
      comment: "",
      operation: null,
      onKeyUp: e => {
        if (e.key === "Enter") {
          this.saveComment();
        }
        if (e.key === "Escape") {
          this.close();
        }
      }
    };
  },

  watch: {
    dialog(val) {
      if (val) {
        this.keyUpHandler = this.onKeyUp.bind(this);
        document.addEventListener("keyup", this.keyUpHandler);
      } else {
        document.removeEventListener("keyup", this.keyUpHandler);
      }
    }
  },

  methods: {
    async open(comments, operation) {
      this.comments = comments.sort((a, b) => {
        return new Date(b.created_at) - new Date(a.created_at);
      });
      this.operation = operation;
      this.dialog = true;
      await Helper.timeout(50);
      document.getElementById('comment-input').focus();
    },

    close() {
      this.dialog = false;
      this.comments = [];
      this.comment = "";
      this.operation = null;
    },

    async saveComment(){
      if(!this.comment) return;
      if(this.operation.status != 3){
        const confirmation = confirm(this.$t('comments_preview_dialog.record_problem'));
        if(!confirmation) return;
        this.operation.status = 3;
        await this.operation.save();
      }
      const comment = {
        text: this.comment,
        table_name: "product_operations",
        table_id: this.operation.id
      };
      await Comment.create(comment);
      this.$emit('commentCreated');
      this.close();
    }
  }
};
</script>

<style scoped>
.preview-box {
  position: relative;
  width: 700px;
  height: 400px;
  overflow-y: auto;
}
.table-data {
  width: 100%;
  height: 370px;
  overflow: auto;
}
.table-data::-webkit-scrollbar {
  width: 10px;
}

.table-data::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.table-data::-webkit-scrollbar-thumb {
  background: rgba(117, 121, 129, 0.952);
}
.border {
  border: solid 1px black;
}
.time-cell {
  width: 150px;
}
.user-cell {
  width: 100px;
}
.comment-cell {
  width: 450px;
}
</style>